import ListItemIcon from '@material-ui/core/ListItemIcon'

export default ListItemIcon
